import { Common, color } from '@stockbit/ui';
import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

import AuthCardLayout from 'global/AuthCardLayout';
import Image from 'global/Image';
import If from 'global/ErrorHandlers/If';
import registerSlice from '../slice';
import { InputPhoneContainer } from '../styled';

const { Button, TelephoneInput, Text } = Common;

interface PhoneRegisterProps {
  onRegister: (phone: string, code: string) => void;
}

interface PhoneRegisterState {
  countryCode: string;
  dialCode: string;
  format: string;
  name: string;
}

function PhoneRegister({ onRegister }: PhoneRegisterProps): JSX.Element {
  const dispatch = useDispatch();
  const [phone, setPhoneNumber] = useState({
    countryCode: '',
    dialCode: '',
    format: '',
    name: '',
    phoneNumber: '',
  });

  const handleVerifyCaptcha = useCallback(
    (token) => {
      dispatch(registerSlice.actions.storeCaptchaToken({ token }));
    },
    [dispatch],
  );

  const handleSendClick = () => {
    onRegister(phone.phoneNumber, phone.dialCode);
  };

  const handlePhoneInputChange = (
    phoneNumber: string,
    countryInfo: PhoneRegisterState,
  ) => {
    setPhoneNumber({ phoneNumber, ...countryInfo });
  };

  const handleResetPhoneNumber = () => {
    setPhoneNumber((prevState) => ({
      ...prevState,
      phoneNumber: phone.dialCode,
    }));
  };

  return (
    <AuthCardLayout wrapperClassName="register">
      <GoogleReCaptcha onVerify={handleVerifyCaptcha} />

      <Text size="24px" align="center" weight="700" color={color.highempahis}>
        Phone Verification
      </Text>

      <Text
        size="16px"
        family="light"
        color={color.highgray}
        style={{ lineHeight: '135%' }}
      >
        We will send you a confirmation code. Input your phone number eg.{' '}
        +6287654321000
      </Text>

      <div>
        <Text size="12px" family="bold" pb="10px">
          Nomor HP
        </Text>

        <InputPhoneContainer>
          <TelephoneInput
            id="phone-input"
            value={phone.phoneNumber}
            country="id"
            placeholder="+62 876-5432-1000"
            onChange={handlePhoneInputChange}
            buttonClass="phone-dropdown-button"
            inputClass="phone-input"
            autoFormat
            enableLongNumbers={15}
            defaultMask="...-....-...."
          />

          <If condition={phone?.phoneNumber}>
            <button onClick={handleResetPhoneNumber} type="button">
              <Image src="/icon/close-fill.svg" alt="" />
            </button>
          </If>
        </InputPhoneContainer>
      </div>

      <Button
        id="send-code"
        type="primary"
        height="44px"
        block
        onClick={handleSendClick}
        disabled={!phone.phoneNumber.slice(phone.dialCode.length)}
      >
        <Text family="bold" color={color.light}>
          Send Verification Code
        </Text>
      </Button>
    </AuthCardLayout>
  );
}

export default PhoneRegister;
